import axios, { AxiosRequestConfig } from "axios"
import { Credentials } from "src/models/instantiateClass";
// EC2: https://qz1k6rmf1g.execute-api.eu-central-1.amazonaws.com/blockchain-helpers
// https://6cvbb4t4465ecwdgtftvudcmce0xhuvc.lambda-url.eu-central-1.on.aws/

const createInstance = (env?: string) => {
  let url = env === 'debug' ? 'https://qz1k6rmf1g.execute-api.eu-central-1.amazonaws.com/blockchain-helpers' : 'https://api.zoidcore.com/blockchain-helpers';
  const instance = axios.create({
    baseURL: url
  })
  return instance;
}

const buildConfig = (initialize: Credentials): AxiosRequestConfig => {
  let config;
  if (initialize.apiKey) {  
    return config = {
      headers: {
        'X-API-Key': initialize.apiKey
      }
    }
  }

    return config = {
      headers: {
        'Authorization': `Bearer ${initialize.authorization}`
      }
  }
}

export const axiosRequest = async (url: string, payload: any, initialize: Credentials) => {
    console.log(`URL ${url}`);
    const config = buildConfig(initialize);
    const axiosInstance = createInstance(initialize.env);
    return await axiosInstance.post(url, payload, config);
 }
